import React from 'react';
import { PropTypes } from 'prop-types';
import HrbTranslate from "../../language/HrbTranslate";
import './PersonalInfoItem.scss'

const PersonalInfoItem = (props) => (
    <div className="hrb-profile-personal-item-container">
        <div className="hrb-profile-personal-item-title">
            <HrbTranslate text={props.title} />
        </div>
        <div className="hrb-profile-personal-item-content">
            {props.value || '-'}
            {props.children}
        </div>
    </div>
);

PersonalInfoItem.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string
};

export default PersonalInfoItem;